import { FUSUS_GREEN } from '@lib/common/constants';

export type ShapeStylesType = {
  style: string;
  strokeOpacity: number;
  strokeWidth: number;
  fillColor: string;
  strokeColor: string;
  fillOpacity: number;
  zIndex: number;
};

export const ACTIVE_EDITABLE_SHAPE_STYLES: ShapeStylesType = {
  style: 'solid',
  strokeWidth: 6,
  strokeColor: FUSUS_GREEN,
  strokeOpacity: 1,
  fillColor: FUSUS_GREEN,
  fillOpacity: 0.2,
  zIndex: 0,
};
